// extracted by mini-css-extract-plugin
export default {"wrapper":"Breadcrumbs_wrapper__pdMcr","separator":"Breadcrumbs_separator__Tycos","crumb-wrapper":"Breadcrumbs_crumb-wrapper__RQjjT","crumb":"Breadcrumbs_crumb__lYkwI"};